import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DisclosureService {
    disclosure$ = new BehaviorSubject(true);

    show(): void {
        this.disclosure$.next(true);
    }

    hide(): void {
        this.disclosure$.next(false);
    }
}
